import React, { Component } from "react";
import Translations from "../../services/translation.service";
import FirebaseAnalytics from "../../services/analytics.service";
import FieldValidity from "../../services/fieldValidity.service";
import User from "../../services/user.service";
import StorefrontTitle from "../shared/storefront-title.component";
import SelectionCard from "./selectionCard";
import hintImg from "../../assets/img/hint.svg";
import EligibityFormSkeleton from "../skeleton/eligibity-form.component";
import SpinnerTimeLoader from "../shared/timeLoading";
import Helpers from "../../helpers/shared.helper";
import ContentSlider from "../shared/contentSlider";
import ModalWrapper from "../shared/modal-wrapper";
import Settings from "../../services/settings.service";
import Storage from "../../services/storage.service";
import CalendarIcon from "../../assets/img/CalendarIcon.svg";
import SelectCheckIcon from "../../assets/img/SelectCheck.svg";
import SelectDownArrowIcon from "../../assets/img/SelectDropDownBlank.svg";
import CheckedImage from "../../assets/img/CheckedImage.svg";
import UncheckedImage from "../../assets/img/UncheckedImage.svg";
import LeftIcon from "../../assets/img/ChevronLeftCal.svg";
import RightIcon from "../../assets/img/ChevronRightCal.svg";
import SearchIcon from "../../assets/img/CountrySearch.svg";
import Select, { components } from "react-select";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import ModalWrapperV2 from "../shared/modal-wrapper-v2";
import CountrySelectModal from "../shared/country-select-modal.component";
import FetchNationalitySkeleton from "../skeleton/eligibilty-fetch-nationality.component";
import moment from "moment";
import "moment/locale/ar-sa";
import "moment/locale/en-ca";
import EligibilityService from "../../services/eligibility.service";
import PhoneWrapper from "../shared/sharedFields/phoneWrapper";

const countriesForFlag = Helpers.convertCountriesListBasedOn(true);
class CountryMenuContainer extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      hasScrollbar: false,
    };
  }

  checkForScrollbar = () => {
    if (this.containerRef.current) {
      if(!Helpers.isSmallDevice()) {
        const childContainer = this.containerRef.current.querySelector('.react-select__menu-list');
        const hasScroll =
        childContainer.scrollHeight > childContainer.clientHeight;
        this.setState({ hasScrollbar: hasScroll });
      } else {
        this.setState({ hasScrollbar: false });
    }
    }
  };

  componentDidMount() {
    this.checkForScrollbar();
    window.addEventListener('resize', this.checkForScrollbar);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.checkForScrollbar();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkForScrollbar);
  }

  render() {
    const { hasScrollbar } = this.state;
    return (
      <components.Menu {...this.props}>
        <div ref={this.containerRef} className={hasScrollbar ? "react-select-custom-country-option-container hasScrollbar" : "react-select-custom-country-option-container hasNoScrollbar"}>
          {this.props.children}
        </div>
      </components.Menu>
    );
  }
}

class EligibityForm extends Component {
  subscriptions = [];

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      agreeDataTerms: false,
      agreeCreditScore: false,
      openNationalityModal: false,
      gendersLoading: false,
      maritalStatusLoading: false,
      genderOptions: [],
      maritalOptions: [],
    };
  }

  componentDidMount() {
    this.props.toggleLoading(true);
    this.getAvailableGenderAndMaritalStatus();
    User.getFlowStatus()
      .then((response) => {
        if (response.data?.flow_status_flags?.Tahaqoq_Reached_max_number_of_retries) {
          this.props.action("EligibilityFailedFinal");
          this.props.toggleLoading(false);
        } else {
          this.props.toggleLoading(false);
        }
      })
      .catch((error) => {
        this.props.toggleLoading(true);
      });
  }

  getAvailableGenderAndMaritalStatus = () => {
    this.setState({
      maritalStatusLoading: true,
      gendersLoading: true
    })
    EligibilityService.availableGenderAndMaritalStatus()
    .then((response) => {
      if(response?.data && response?.data?.marital_statuses && response?.data?.marital_statuses?.length > 0) {
        let localStatuses = [];
        for (const item of response?.data?.marital_statuses) {
          localStatuses.push({
            value: item?.Code,
            label: Translations.keys[`marital_status_${item.Code}`] || Translations.activeLang === "en" ? item.NameEn : item.NameAR
          });
        }
        
        this.setState({
          maritalStatusLoading: false,
          maritalOptions: localStatuses
        })
      }

      if(response?.data && response?.data?.genders && response?.data?.genders?.length > 0) {
        let localGenders = [];
        for (const item of response?.data?.genders) {
          localGenders.push({
            value: item?.Code,
            label: Translations.keys[`gender_${item.Code}`] || Translations.activeLang === "en" ? item.NameEn : item.NameAR
          });
        }
        this.setState({
          gendersLoading: false,
          genderOptions: localGenders,
        })
      }
    })
    .catch(() => {
      window.location.reload();
    })
  }

  getFlag = (code) => {
    let flag = "";
    if(countriesForFlag[code]) {
      flag = require("../../assets/img/flagsRounded/country_" +
      countriesForFlag[code]?.iso_2code?.toLowerCase() +
      ".webp");
    }
    if(flag) {
      return flag;
    } else {
      return "";
    }
  }

  handleModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      openModal: !this.state.openModal
    })
    FirebaseAnalytics.about_credit_score_info();
  };

  handleNationalityModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      openNationalityModal: !this.state.openNationalityModal
    })
  };

  handleTermsChecked = () => {
    // For Postpaid
    if(Helpers.isPlanPostPaidByPC()) {
      if(this.state.agreeDataTerms && this.state.agreeCreditScore) {
        return false;
      } else {
        return true;
      }
    } else {
      // For Plans except Postpaid
      if (this.state.agreeDataTerms) {
        return false;
      } else {
        return true;
      }
    }
  }

  staticLanguageLink = (link, linkAR) => {
    if (Translations.activeLang === "en") {
        return link;
    }
    if (Translations.activeLang === "ar") {
        return linkAR;
    }
    return "#";
  };

  getSliderData = () => {
    const poModalKey = `credit_score_popup_json`;
    let business = Storage.get("business", true);
    let poModalData = null;
    if (business) {
      business = JSON.parse(business);
      if(business[poModalKey]) {
        poModalData = business[poModalKey]
      }
    }
    return poModalData
  }

  IconOption = props => (
    <components.Option {...props}>
      {props.isSelected ?
        <div className="react-select-custom-option">
          {props.data.label}
          <img src={SelectCheckIcon} alt=""/>
        </div>
      : 
        <div className="react-select-custom-option">
          {props.data.label}
        </div>
      }
    </components.Option>
  );

  
  MenuContainer = props => (
    <components.Menu {...props}>
    <div className="react-select-custom-option-container">
      {props.children}
    </div>
  </components.Menu>
  );

  CountryOption = props => (
    <>
    <components.Option {...props}>
        <div className="react-select-custom-country-option">
            <>
              <div>
                {/* <img src={this.getFlag(props.data.isoCode)} alt="" /> */}
                {props.data.label}
              </div>
              {/* {props.data?.isoCode && props.data?.isoCode !== "null" ? <span>({countriesForFlag[props.data.isoCode]?.dial_code})</span> : ""} */}
            </>
        </div>
    </components.Option>
    </>
  );

  CountryControl = ({children, ...props}) => (
    <components.Control {...props}>
      <div className="react-select-custom-country-input">
        <img src={SearchIcon} alt="" /> 
        {children}
      </div>
    </components.Control>
  );

  DropdownIndicator = () => {
    return <img src={SelectDownArrowIcon} alt=""/>
  }

  transformOptions = (options) => {
    return options?.map(option => ({
      label: option.City,
      value: option.Id,
    }));
  }

  transformNationalitiesOptions = (options) => {
    return options?.map(option => ({
      label: option.Nationality,
      value: option.Id,
      isoCode: option?.isoCode
    }));
  }

  IconIndicator = (props) => {
    return <img src={props} alt="" />
  }

  IconIndicatorPicker = (props) => {
    const scrollToDOB = () => {
      // Get the target section
      const section = document.getElementById('react-select-dob');
  
      // Scroll to the section smoothly
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }

    return <img src={props} alt="" onClick={() => scrollToDOB()}/>
  }

  getNationalityName = (selectedNationality) => {;
    const nationalities = this.props.state.availableNationalities?.filter(item => item.Id === selectedNationality) || "";
    return nationalities[0].Nationality
  }

  checkPassport = () => {
    if(this.props.state.showPassport) {
      // Check for Passport Validation
      if(this.props.state.passportiDValid && this.props.state.passportiDTouched) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  render() {
    let prefix = "scr_3.3.1_Check_Eligibility_";
    let prefix4 = "stm_eligibility_";

    const customNoOptionsMessage = () => (
        <div>&nbsp;</div>
    );

    let stfidType = null;
    if (this.props.state.idType) {
      stfidType = this.props.state.idType.map(option => {
        return (
          <SelectionCard
            key={option.Id}
            keyID={option.Id}
            card={option}
            selectedCard={this.props.state.selectedIdType}
            handleSelectedCard={this.props.updateIdType}
          />
        );
      });
    }


  if(Translations.activeLang === "ar") {
    moment.locale("ar-sa");
  }
    
  if(Translations.activeLang === "en") {
    moment.locale("en-ca");
  }

    let content = (
      <>
        <div className="eligibility-form-container">
          <StorefrontTitle
            title={Translations.keys[prefix4 + "check_eligibility"]}
            desc={Translations.keys[prefix4 + "quick_check"]}
          />
          <div className="selection-card-container storefront-scrollbar-hide">
            {stfidType}
          </div>
          <div className={`${Helpers.shouldShowAnySimahField() ? "field-section field-section-wide" : "field-section"}`}>
            {this.props.state.showPassport && <>
              <div className="field-container">
                <label>{this.props.state.selectedIdType ? `${Translations.keys[`scr_5.9.1_title_passport_${Helpers.updateAPIString(this.props.state.selectedIdType)}_number`] || Translations.keys[prefix4 + "passport_number"]}` : "Passport Number"}</label>
                <input
                  className={
                    "storefront-search-input " +
                    (!this.props.state.passportiDTouched || (this.props.state.passportiDTouched && this.props.state.passportiDValid)
                      ? "valid"
                      : "invalid") +
                    (this.props.state.passportid_number ? " filled" : "")
                  }
                  autoComplete="off"
                  type="text"
                  name="passportid_number"
                  ref="passportid_number"
                  id="passportid_number"
                  require="true"
                  placeholder={this.props.state.selectedIdType ? `${Translations.keys[`scr_5.9.1_placeholder_passport_${Helpers.updateAPIString(this.props.state.selectedIdType)}_number`] || Translations.keys[prefix4 + "passport_number_placeholder"]}` : "Enter passport number"}
                  value={this.props.passportid_number}
                  onChange={this.props.updatePassportIdNumber}
                />
                <div className="hint-section">
                  <img src={hintImg} alt="Message" />
                  <p>{this.props.state.selectedIdType ? `${Translations.keys[`scr_5.9.1_hint_passport_${Helpers.updateAPIString(this.props.state.selectedIdType)}_number`] || Translations.keys[prefix4 + "id_number_hint"]}` : ""}</p>
                </div>
              </div>
            </>}
            <div className="field-container">
              <label>{this.props.state.selectedIdType ? `${Translations.keys[`scr_5.9.1_title_id_type_${Helpers.updateAPIString(this.props.state.selectedIdType)}_number`] || Translations.keys[prefix4 + "id_number"]}` : ""}</label>
              <input
                className={
                  "storefront-search-input " +
                  (!this.props.state.iDTouched || (this.props.state.iDTouched && this.props.state.iDValid)
                    ? "valid"
                    : "invalid") +
                  (this.props.state.id_number ? " filled" : "")
                }
                autoComplete="off"
                type="text"
                name="id_number"
                ref="id_number"
                id="id_number"
                require="true"
                placeholder={this.props.state.selectedIdType ? `${Translations.keys[`scr_5.9.1_placeholder_id_type_${Helpers.updateAPIString(this.props.state.selectedIdType)}_number`] || Translations.keys[prefix4 + "id_number_placeholder"] || Translations.keys[prefix4 + "id_number"]}` : ""}
                value={this.props.id_number}
                onChange={
                  this.props.updateIdNumber
                }
              />
              <div className="hint-section">
                <img src={hintImg} alt="Message" />
                <p>{this.props.state.selectedIdType ? `${Translations.keys[`scr_5.9.1_hint_id_type_${Helpers.updateAPIString(this.props.state.selectedIdType)}_number`] || Translations.keys[prefix4 + "id_number_hint"]}` : ""}</p>
              </div>
            </div>
            <div className={`${Helpers.shouldShowAnySimahField() ? "field-container-dynamic" : "field-section"}`}>
              {Helpers.shouldSimahShowFields("first_name") ?
              <div className="field-container">
                <label>{Translations.keys["stm_eligibility_first_name"] || "First name"}</label>
                <input
                  className={
                    "storefront-search-input " +
                    (!this.props.state.firstName.touched || (this.props.state.firstName.touched && this.props.state.firstName.valid)
                      ? "valid"
                      : "invalid") +
                    (this.props.state.firstName.value ? " filled" : "")
                  }
                  autoComplete="off"
                  type="text"
                  name="firstName"
                  ref="firstName"
                  id="firstName"
                  require="true"
                  placeholder={Translations.keys["stm_eligibility_enter_first_name"] || "Enter first name"}
                  value={this.props.state.firstName.value}
                  onChange={(e) => {
                    if(Helpers.inputChar(e, Helpers.getEligbilityPOValueObject("eligibility_max_first_name_length"))) {
                      this.props.updateFirstName(e);
                    }
                  }}
                />
              </div> : ""}
              {Helpers.shouldSimahShowFields("last_name") ?
              <div className="field-container">
                <label>{Translations.keys["stm_eligibility_last_name"] || "Last name"}</label>
                <input
                  className={
                    "storefront-search-input " +
                    (!this.props.state.lastName.touched || (this.props.state.lastName.touched && this.props.state.lastName.valid)
                      ? "valid"
                      : "invalid") +
                    (this.props.state.lastName.value ? " filled" : "")
                  }
                  autoComplete="off"
                  type="text"
                  name="lastName"
                  ref="lastName"
                  id="lastName"
                  require="true"
                  placeholder={Translations.keys["stm_eligibility_enter_last_name"] || "Enter last name"}
                  value={this.props.state.lastName.value}
                  onChange={(e) => {
                    if(Helpers.inputChar(e, Helpers.getEligbilityPOValueObject("eligibility_max_last_name_length"))) {
                      this.props.updateLastName(e);
                    }
                  }
                }
                />
              </div> : ""}
              {Helpers.shouldSimahShowFields("date_of_birth") ?
              <div id="react-select-dob" className={`field-container date-picker-container ${this.props.state.birthDate.valid ? "valid-birth" : "invalid-birth"}`} style={{ direction: Translations.activeLang === "en" ? 'ltr' : 'rtl' }}>
                <label>{Translations.keys["stm_eligibility_birth_date"] || "Birth date"}</label>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={Translations.activeLang === "en" ? "en-ca": "ar-sa"}>
                  <DesktopDatePicker
                    format="DD/MM/YYYY"
                    inputFormat="DD/MM/YYYY"
                    // date_format_for_dob
                    disableFuture
                    value={this.props.state.birthDate.value}
                    displayWeekNumber
                    views={["year", "month", "day"]}
                    slotProps={{ textField: { variant: 'filled' }}}
                    onChange={(e) => {
                      this.props.updateBirthDate(e);
                    }}
                    maxDate={() => new Date()}
                    components={{
                      OpenPickerIcon: () => this.IconIndicatorPicker(CalendarIcon),
                      LeftArrowIcon: () => this.IconIndicator(Translations.activeLang === "en" ? RightIcon : LeftIcon),
                      RightArrowIcon: () => this.IconIndicator(Translations.activeLang === "en" ? LeftIcon : RightIcon),
                      SwitchViewIcon: () => null,
                    }}
                    PopperProps={{
                      placement: 'bottom-start', // You can adjust the placement here
                      style: { zIndex: 1300 } // Adjust zIndex to ensure it's on top of other elements
                    }}
                    dayOfWeekFormatter={(day) => `${day}`}
                    renderInput={({ inputProps, ...restParams }) => (
                      <TextField
                        {...restParams}
                        inputProps={{
                          ...inputProps,
                          placeholder: Translations.keys["stm_date_format"] || "DD/MM/YYYY",
                        }}
                        size="medium"
                        sx={{
                          '& .MuiInputBase-input::placeholder': {
                            opacity: 1,
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
                {!this.props.state.birthDate.valid ? <span className="error-msg">{Translations.keys["stm_eligibility_invalid_birth_date"] || "Please enter valid DOB"}</span> : null}
              </div> : ""}
              <div className="field-container">
                <label>{Translations.keys[prefix4 + "nationality"]}</label>
                {this.props.state.fetchingNationality ? <FetchNationalitySkeleton /> : 
                <div className="react-custom-select-popup" onClick={this.handleNationalityModal}>
                    <span>{this.props.state.selectedNationalityId && this.props.state.availableNationalities.length > 0 ? this.getNationalityName(this.props.state.selectedNationalityId) : Translations.keys[prefix + "choose_nationality"]}</span>
                    <img src={SelectDownArrowIcon} alt=""/>
                </div>}
              </div>
          
              {Helpers.shouldSimahShowFields("marital_status") ?
              <div className="field-container">
                <label>{Translations.keys["stm_eligibility_marital_status"] || "Marital Status"}</label>
                {this.state.maritalStatusLoading ? <FetchNationalitySkeleton /> :
                <Select
                  unstyled
                  className="react-select-custom"
                  placeholder={Translations.keys["stm_eligibility_choose_marital_status"] || "Choose marital Status"}
                  isSearchable={false}
                  name="selectedMaritalId"
                  options={this.state.maritalOptions}
                  components={{ Option: this.IconOption, Menu: this.MenuContainer, DropdownIndicator: this.DropdownIndicator }}
                  onChange={(e) => {
                    this.props.updateMaritalStatus(e);
                  }}
                  value={this.state.maritalOptions?.filter(option => 
                    option.value === this.props.state.maritalStatus.value
                  )}
                  defaultValue={this.state.maritalOptions?.filter(option => 
                    option.value === this.props.state.maritalStatus.value
                  )}
                />}
              </div> : ""}
              {Helpers.shouldSimahShowFields("gender") ?
              <div className="field-container">
                <label>{Translations.keys["stm_eligibility_gender"] || "Gender"}</label>
                {this.state.gendersLoading ? <FetchNationalitySkeleton /> :
                <Select
                  unstyled
                  className="react-select-custom"
                  placeholder={Translations.keys["stm_eligibility_choose_gender"] || "Choose Gender"}
                  isSearchable={false}
                  name="selectedGenderId"
                  options={this.state.genderOptions}
                  components={{ Option: this.IconOption, Menu: this.MenuContainer, DropdownIndicator: this.DropdownIndicator }}
                  onChange={(e) => {
                    this.props.updateGender(e);
                  }}
                  value={this.state.genderOptions?.filter(option => 
                    option.value === this.props.state.gender.value
                  )}
                  defaultValue={this.state.genderOptions?.filter(option => 
                    option.value === this.props.state.gender.value
                  )}
                />}
              </div> : ""}
              {this.props?.showPhone ?
              <div className="field-container">
                <label>{Translations.keys[prefix4 + "phone_number"] || "Phone Number"}</label>
                <div
                  className={!this.props?.countryDisabled ? "storefront-two-fields" : "storefront-single-field"}
                >
                  {!this.props?.countryDisabled ?
                    <div
                      className="country-select-container"
                    >
                      <CountrySelectModal
                        defaultCountry={this.props.phoneCode.value}
                        updateFieled={this.props.handleCountryCode} 
                      />
                    </div>
                    :
                    null
                  }
                  <PhoneWrapper>
                    <input
                      type="tel"
                      className={
                        "storefront-search-input " +
                        (!this.props.state.phone.touched || (this.props.state.phone.touched && this.props.state.phone.valid)
                          ? "valid"
                          : "invalid") +
                        (this.props.state.phone.value ? " filled" : "")
                      }
                      style={{paddingLeft: "47px !important"}}
                      name="contact_number"
                      id="contact_number"
                      value={this.props.state.phone.value}
                      onChange={event => {
                        if(event.target.value === "0") {
                          return;
                        }
                        if (FieldValidity.inputDigits(event, 10)) {
                          this.props.updateContactField(event, "form", 'phone')
                        }
                      }}
                      placeholder={Translations.keys["stm_search_input_placeholder"]}
                    />
                  </PhoneWrapper>
                </div>
                <div className="hint-section">
                  <img src={hintImg} alt="Message" />
                  <p>{Translations.keys["3.3.2.B_enter_associated_num"]}</p>
                </div>
              </div> : null}
              <div className="field-container">
                <label>{Translations.keys[prefix4 + "residence"]}</label>
                {this.props.state.availableSaudiCities?.length > 0 ?
                <Select
                  unstyled
                  className="react-select-custom"
                  placeholder={Translations.keys[prefix + "choose_cities"]}
                  name="selectedCityId"
                  isSearchable={false}
                  options={this.transformOptions(this.props.state.availableSaudiCities)}
                  components={{ Option: this.IconOption, Menu: this.MenuContainer, DropdownIndicator: this.DropdownIndicator }}
                  onChange={this.props.updateCity}
                  value={this.transformOptions(this.props.state.availableSaudiCities)?.filter(option => 
                    option.value === this.props.state.selectedCityId
                  )}
                  defaultValue={this.transformOptions(this.props.state.availableSaudiCities)?.filter(option => 
                    option.value === this.props.state.selectedCityId
                  )}
                /> : <FetchNationalitySkeleton />}
              </div>
            </div>          
            
            <div className="eligibility-checkbox-container">
              <div className={`checkbox-container storefront-checkbox ${Helpers.isSafari() ? "safari" : ""}`}>
                <input
                  style={{ display: "none" }}
                  type="checkbox"
                  name="agreeDataTerms"
                  id="agreeDataTerms"
                  checked={this.state.agreeDataTerms}
                  onChange={(event)=>{
                    this.setState({
                      agreeDataTerms: event.target.checked
                    })
                  }}
                />
                <img
                  className="checkbox-image"
                  src={this.state.agreeDataTerms ? CheckedImage : UncheckedImage}
                  alt="Checkbox"
                  onClick={()=>{
                    this.setState({
                      agreeDataTerms: !this.state.agreeDataTerms
                    })
                  }}
                />
                <label htmlFor="agreeDataTerms">{Translations.keys["stm_eligibility_term_agree"]}{" "}<a href={this.staticLanguageLink(Settings?.footer?.terms_and_conditions, Settings?.footer?.terms_and_conditionsAR)} target="_blank" rel="noopener noreferrer">{Translations.keys["stm_eligibility_term_learn_more"]}</a></label>
              </div>
              {Helpers.isPlanPostPaidByPC() ?
                <div className={`checkbox-container storefront-checkbox ${Helpers.isSafari() ? "safari" : ""}`}>
                  <input
                    style={{ display: "none" }}
                    type="checkbox"
                    name="agreeCreditScore"
                    id="agreeCreditScore"
                    checked={this.state.agreeCreditScore}
                    onChange={(event)=>{
                      this.setState({
                        agreeCreditScore: event.target.checked
                      })
                    }}
                  />
                  <img
                    className="checkbox-image"
                    src={this.state.agreeCreditScore ? CheckedImage : UncheckedImage}
                    alt="Checkbox"
                    onClick={()=>{
                      this.setState({
                        agreeCreditScore: !this.state.agreeCreditScore
                      })
                    }}
                  />
                  <label htmlFor="agreeCreditScore">{Translations.keys["stm_eligibility_credit_score_agree"]}{" "}<span onClick={this.handleModal}>{Translations.keys["stm_eligibility_credit_score"]}</span></label>
                </div>
              : null}
            </div>

            <button
              className={"common-button"}
              disabled={!this.props.state.formValid || !this.props.state.iDValid || this.handleTermsChecked() || this.props.state.simahValidationFailed || this.checkPassport()}
              onClick={() => {
                FirebaseAnalytics.button_clicked(prefix + "btn_label")
                this.props.checkEligibilityRoot();
              }}
            >
              {Translations.keys[prefix4 + "check"]}
            </button>
          </div>
        </div>
        {this.state.openModal && 
          <ModalWrapper handleToggleModal={this.handleModal}>
            <ContentSlider
              imagesFolder="information_popup_images"
              sliderData={this.getSliderData()}
              closeModal={this.handleModal} 
            />
          </ModalWrapper>
        }
        {this.state.openNationalityModal &&
          <ModalWrapperV2 handleToggleModal={this.handleNationalityModal} heading={"stm_eligibility_select_country"} closeBtn="stf_eligibility_modal_close">
            <div className="search-country-select">
              <Select
                unstyled
                autoFocus
                noOptionsMessage={customNoOptionsMessage} // Custom no options message
                classNamePrefix="react-select"
                className="react-select-country-custom"
                placeholder={Translations.keys["stm_eligibility_placeholder_search"]}
                name="selectedNationalityId"
                isSearchable={true}
                options={this.transformNationalitiesOptions(this.props.state.availableNationalities)}
                components={{ Control: this.CountryControl, Option: this.CountryOption, Menu: CountryMenuContainer, DropdownIndicator: () => null }}
                onChange={(e) => {
                  this.props.updateNationality(e);
                  this.setState({
                    openNationalityModal: !this.state.openNationalityModal
                  })
                }}
                value={this.transformNationalitiesOptions(this.props.state.availableNationalities)?.filter(option => 
                  option.value === this.props.state.selectedNationalityId
                )}
                defaultValue={this.transformOptions(this.props.state.availableNationalities)?.filter(option => 
                  option.value === this.props.state.selectedNationalityId
                )}
                formatOptionLabel={() => (
                  <span>{Translations.keys["stm_eligibility_placeholder_search"]}</span> // Show placeholder when selected
                )}
                menuIsOpen
              />
            </div>
          </ModalWrapperV2>
        }
      </>
    );
    if (this.props.state.loading || !this.props.state.basic_data_loaded) {
      content = <EligibityFormSkeleton />;
    }
    if (this.props.state.actionLoading) {
      content = <SpinnerTimeLoader />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

export default EligibityForm;